import { FC } from 'react';
import { ProCheckbox } from '../antd';
import SimpleFormDisabled from './subpage/disabled';
import SimpleFormItem from './subpage/simpleFormItem';
import { BaseSimpleFormProps, SimpleFormItemEnum } from './interface';
import { useLayoutContext } from '../PageLayout/context/LayoutContext';
import { CheckboxGroupProps } from 'antd/lib/checkbox';

export interface SimpleFormCheckboxGroupProps extends BaseSimpleFormProps {
  checkboxGroupProps?: CheckboxGroupProps;
  enumCode?: string;
}
const SimpleFormCheckboxGroup: FC<SimpleFormCheckboxGroupProps> = props => {
  const {
    disabledRender,
    checkboxGroupProps,
    form,
    enumCode,
    ...restProps
  } = props;
  const { enumData } = useLayoutContext();
  let options: any[] = [];
  if (enumCode && enumData) {
    options = enumData[enumCode] ? enumData[enumCode].items || [] : [];
  }
  return (
    <SimpleFormItem {...restProps}>
      {checkboxGroupProps?.disabled ? (
        <SimpleFormDisabled
          name={props.name}
          form={form}
          options={checkboxGroupProps?.options || options}
          render={disabledRender}
        />
      ) : (
        <ProCheckbox.Group options={options} {...checkboxGroupProps} />
      )}
    </SimpleFormItem>
  );
};

SimpleFormCheckboxGroup.displayName =
  SimpleFormItemEnum.SimpleFormCheckboxGroup;

export default SimpleFormCheckboxGroup;
